import React from "react";
import JavaScriptGuideContent from "./javascript.mdx";

const JavaScriptGuide: React.FC = () => <JavaScriptGuideContent />;

export default JavaScriptGuide;
